import * as React from "react";
import { SVGProps } from "react";
const SvgPlay = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="none" viewBox="0 0 32 32" {...props}>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M22.983 14.301c.9.5 1.299 1.599.8 2.598-.2.4-.5.7-.8.8l-11.787 6.493c-.998.6-2.297.3-2.896-.699-.2-.3-.3-.6-.3-.999V9.506c.096-1.147 1.014-2.02 2.142-2.006l.155.008c.3 0 .7.1 1 .3L22.982 14.3l.001.001Z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgPlay;
